import React from 'react';
import { PageTitle as PageTitleBase } from '@groupby/ui-components';
import { LocalizedMessage } from '@/localization';
export const PageTitle = () => (<PageTitleBase title={<LocalizedMessage messageKey="RELEASE_NOTES"/>} description={<LocalizedMessage messageKey="RELEASE_NOTES_DESCRIPTION"/>}/>);
export default PageTitle;
